import {HStack, Show} from 'platform/foundation';

import type {CustomerInsightsIdentity} from '../../../types/CustomerInsightsViewModel';
import {CustomerInsightsEmailAction} from './CustomerInsightsEmailAction';
import {CustomerInsightsPhoneAction} from './CustomerInsightsPhoneAction';

export interface CustomerInsightsContactActionsProps {
  identity: Pick<CustomerInsightsIdentity, 'id' | 'phone' | 'email'>;
}

export function CustomerInsightsContactActions(props: CustomerInsightsContactActionsProps) {
  return (
    <HStack spacing={2} align="center" wrap minWidth={0}>
      <Show when={props.identity.phone}>
        <CustomerInsightsPhoneAction
          customerId={props.identity.id}
          value={props.identity.phone ?? ''}
        />
      </Show>
      <Show when={props.identity.email}>
        <CustomerInsightsEmailAction
          customerId={props.identity.id}
          value={props.identity.email ?? ''}
        />
      </Show>
    </HStack>
  );
}
